import { render } from "./ModalExportSucces.vue?vue&type=template&id=1f455d11"
import script from "./ModalExportSucces.vue?vue&type=script&lang=js"
export * from "./ModalExportSucces.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__